<template>
  <div>
    <!-- 弹窗 -->
    <van-popup v-model="popShow" :close-on-click-overlay="false">
      <img class="pop-logo" src="../../../assets/images/lottery/pop_extra.png" />
      <div class="pop-content">
        <div class="pop-content-title">{{ popMsg.title }}</div>
        <div v-html="popMsg.desc" class="pop-content-msg"></div>
        <LotteryPopupStep class="pop-step-row" v-if="!getCoupon" />
        <LotteryPopupCoupon v-else />
        <CollectCardsPopup v-if="springActivityData && cardsValue"/>
        <div v-html="popMsg.result" class="pop-content-result"></div>
        <div class="pop-content-btn" @click="popClick">{{ popMsg.btn }}</div>
      </div>

      <div class="pop-close" @click="popClose">
        <img src="../../../assets/images/lottery/off_icon.png" />
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import LotteryPopupStep from './lottery-popup-step'
import LotteryPopupCoupon from './lottery-popup-coupon'
import CollectCardsPopup from './collect-cards-popup'
export default {
  name: 'LotteryPopup',
  components: {
    LotteryPopupStep,
    LotteryPopupCoupon,
    CollectCardsPopup
  },
  data () {
    return {
      popShow: false,
      getCoupon: false,
      popMsg: {
        title: '',
        desc: '',
        result: '',
        btn: ''
      }
    }
  },
  computed: {

    ...mapState({
      times: state => state.lottery.scanTimes,
      lotteryCount: state => state.lottery.lotteryCount,
      scanCountMonth: state => state.lottery.scanCountMonth,
      scanCountCurrent: state => state.lottery.scanCountCurrent,
      scanPoint: state => state.lottery.scanPoint,
      springActivityData: state => state.lottery.springActivityData,
      cardsValue: state => state.lottery.cardsValue,
      couponCountAll: state => state.lottery.couponCountAll
    })

  },
  watch: {
    times () {
      this.setPopText()
    }
  },

  methods: {

    // 设置弹窗信息
    setPopText () {
      if (this.times === 10) {
        this.popMsg = {
          title: `恭喜您获得${this.scanPoint}积分`,
          desc: `您当月已获得<span style="color:#ed4836">${this.lotteryCount}</span>张奖券`,
          result: `本月奖池已累计<span style="color:#ed4836">${this.couponCountAll}</span>，离大奖仅一步之遥`,
          btn: '点击领取奖券'
        }
      } else {
        this.popMsg = {
          title: `恭喜您获得${this.scanPoint}积分`,
          desc: `再扫码<span style="color:#ed4836">${10 - this.times}</span>次即可获得一张奖券!`,
          result: `本次扫码共<span style="color:#ed4836">${this.scanCountCurrent}</span>个，本月累计扫码<span style="color:#ed4836">${this.scanCountMonth}</span>个`,
          btn: '继续扫一扫'
        }
      }
    },

    // 点击弹窗按钮
    popClick () {
      if (this.popMsg.btn === '继续扫一扫') {
        this.$emit('popClick')
        this.popClose()
      } else {
        this.receiveCoupon()
      }
    },

    // 领取奖券
    receiveCoupon () {
      this.$store.dispatch('getCouponCount')
      this.getCoupon = true
      this.popMsg = {
        title: '恭喜您获得一张奖券!',
        desc: `本月已累计获得<span style="color:#ed4836">${this.lotteryCount}</span>张奖券`,
        result: '奖券已放入卡包，请前往查看',
        btn: '继续扫一扫'
      }
    },

    popAppear () {
      this.getCoupon = false
      this.popShow = true
    },

    popClose () {
      this.popShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.van-popup {
  width: 270px;
  min-height: 450px;
  background-color: rgba(0, 0, 0, 0);
  .pop-logo {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    max-width: 150px;
  }
  .pop-content {
    width: 265px;
    height: 273px;
    padding: 40px 15px 10px 15px;
    margin: 30px auto 0;
    background-color: #fff;
    background-image: url('../../../assets/images/lottery/pop_content.png');
    background-size: 100%;
    text-align: center;
    border-radius: 10px;
    box-sizing: border-box;
    .pop-content-title {
      font-weight: bold;
      font-size: 18px;
    }
    .pop-content-msg {
      font-size: 12px;
      color: #aaa;
      margin-top: 8px;
    }
    .pop-step-row {
      margin-bottom: 30px;
    }
    .pop-content-result {
      color: #666;
      font-size: 12px;
    }
    .pop-content-btn {
      width: 178px;
      height: 50px;
      background-image: url('../../../assets/images/lottery/scan_btn.png');
      background-size: 100%;
      border-radius: 10px;
      text-align: center;
      line-height: 50px;
      color: #2c535d;
      font-weight: bold;
      font-size: 20px;
      margin: 10px auto;
    }
  }
  .pop-close {
    width: 39px;
    height: 39px;
    margin: 30px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
